import PrePaymentPaymentItem from '../../../Domain/PrePaymentPaymentItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import React from 'react';
import ClientPaymentService from '../../../Services/ClientPaymentService';

export default class ClientPrePaymentDetailsPaymentsTab extends React.Component {
  static defaultProps = {
    prepaymentId: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: props.prepaymentId
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={PrePaymentPaymentItem}
          serviceFunction={ClientPaymentService.GetPrePaymentPaymentsBySearching}
          convertDBItemsFunction={ClientPaymentService.ConvertPrePaymentPaymentDBItems}
          searchItem={this.state.searchItem}
          orderBy='PaymentDate'
          orderDirection='Desc'
          errorCode='CPPDPT28'
        />
      </div>
    );
  }
}
